module.exports = __webpack_public_path__ + "static/img/zf2.7d6100f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zf2.png
// module id = JHso
// module chunks = 1